export function Fallback() {
    return (
        <div className='grid h-[400px]'>
            <h1 className='m-auto'>Loading...</h1>
        </div>
    );
}
